import React, { Component } from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner, Table } from "react-bootstrap";
import Crypt from '../lib/Crypt';
import swal from 'sweetalert';
import C from '../lib/Config';

export default class AdverseEffectTerPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            adverseEffectTerChemo: '', 
            adverseEffectTerReportArr: [],
            adverseEffectTerReport: '',
            adverseEffectTerReportName: '',
            chemoMedAdvEffectXId: 0

        }; 
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        this.getAllAdverseEffectMaster();  
    }
    handleChange(event){
        if(event.target.name === 'adverseEffectTerChemo'){
            this.setState({adverseEffectTerChemo: event.target.value});
        }
        if(event.target.name === 'adverseEffectTerReport'){
            this.setState({adverseEffectTerReport: event.target.value});
            this.setState({adverseEffectTerReportName: event.target.options[event.target.selectedIndex].text});
        } 
    }
    // validateAdverseEffTer(){
    //     let formIsValid = true;
    //     let errors = {};
    //     if (this.state.adverseEffectTerChemo === "" || this.state.adverseEffectTerChemo === null) {
    //         errors["adverseEffectTerChemo"] = "Please enter first name";
    //         formIsValid = false;
    //     }
    //     if (this.state.adverseEffectTerReport === "" || this.state.adverseEffectTerReport === null) {
    //         errors["adverseEffectTerReport"] = "Please select schedule for doctor visit";
    //         formIsValid = false;
    //     } 
    //     this.setState({protocol: errors });
    //     return formIsValid;
    // }
    getAllAdverseEffectMaster = async () => {
        fetch(C.getUrl() + '/adverseEffectMaster/getAllAdverseEffectMaster')
        .then(res => res.json())
        .then(res => {
            if (!res || !res.message) return;
            let resObj = JSON.parse(res.message);
            if (!Array.isArray(resObj)) return;
            var arr = [];
            resObj.forEach(function (d) {
                arr.push({ id: d.selectionId, name: d.selectionValue });
            });
            this.setState({ adverseEffectTerReportArr: arr });
        })
        .catch(err => {
            console.error("Error fetching adverse effects: " + err);
        });
    }
    saveAdverseTer(event){
        let data = {
            reportID: this.state.adverseEffectTerReport, 
            reportName: this.state.adverseEffectTerReportName,
            message: this.state.adverseEffectTerChemo,
            chemoMedAdvEffectXId: this.state.chemoMedAdvEffectXId
        }
        this.props.saveAdvEffTerminate(data);
       
    }
    render() {
        const { showAdverseEffectTerPopup, closeModal} = this.props;
        const closePreviewModal = () => {
            closeModal();
        }
        const { adverseEffectTerReportArr } = this.state;
        return (
            <div>
                <Modal id="report" show={showAdverseEffectTerPopup} centered animation={true} scrollable={true} size="md">
                    <Modal.Header closeButton onClick={() => closePreviewModal()}>
                        <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">Adverse Event Termination</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container fluid>
                            <Row>
                                <Col lg="12">
                                    <Form.Group>
                                        <Form.Label>Adverse Event</Form.Label>
                                        <Form.Control as="select" id="" name='adverseEffectTerReport' value={this.state.adverseEffectTerReport} onChange={this.handleChange}>
                                            <option value="DEFAULT">- Select Adverse Event -</option>
                                            {
                                                adverseEffectTerReportArr.map((item, i) => {
                                                        return (
                                                            <option key={item.id} value={item.id}>{`${item.name}`}</option>
                                                        );
                                                    })
                                                }
                                        </Form.Control>
                                    </Form.Group>
                                    {/* <div className="invalid-feedback">{this.state.protocol["chemoMedicine"]}</div> */}
                                </Col>
                                <Col lg='12'>
                                    <Form.Group> 
                                        <Form.Group>
                                            <Form.Label>Message</Form.Label>
                                            <Form.Control as='textarea' placeholder='' rows={2} name='adverseEffectTerChemo' onChange={this.handleChange}/>
                                            {/* <div className="invalid-feedback">{this.state.protocol["instructNurse"]}</div> */}
                                        </Form.Group>
                                    </Form.Group>
                                </Col> 
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer className='text-center'>
                        <Button className="btn btn-secondary" onClick={this.saveAdverseTer.bind(this)}>
                            {this.state.saveLoader && (
                                <Spinner className='mr-2' animation='border' size='1.5rem' />
                            )}
                            Add 
                        </Button>
                        <Button variant="outline-danger" onClick={() => closePreviewModal()}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}